// Frontend environment configuration
// Note: In React, environment variables must be prefixed with REACT_APP_
// to be accessible in the browser

// Utility function to clean and validate URLs from environment variables
const cleanUrl = (url: string | undefined): string => {
  if (!url) return '';
  // Remove all quotes (single and double) from anywhere in the string
  let cleaned = url.replace(/["']/g, '');
  // Trim all whitespace from both ends
  cleaned = cleaned.trim();
  return cleaned;
};

// Get environment from custom env variable or fallback to NODE_ENV
const appEnv = process.env.REACT_APP_ENV || process.env.NODE_ENV;

export const config = {
  // API Configuration
  api: {
    baseUrl:
      appEnv === 'development' ? cleanUrl(process.env.REACT_APP_LOCAL_BASE_URL)
        : appEnv === 'staging' ? cleanUrl(process.env.REACT_APP_STAGING_BASE_URL) 
        : appEnv === 'UAT' ? cleanUrl(process.env.REACT_APP_UAT_BASE_URL) 
        : cleanUrl(process.env.REACT_APP_BASE_URL) || "ENV_NOT_SET",

    // baseUrl: 'http://localhost:8000/api',
    // baseUrl: 'https://rnetsbe.uat.metaphi.in/api',
    // baseUrl: cleanUrl(process.env.REACT_APP_BASE_URL) || 'ENV_NOT_SET',
  },
};

